import { Button } from "@sellar-io/components";
import { useForm } from "react-hook-form";
import { v4 } from "uuid";
import { Alert } from "../../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../../hooks/api/v2/apiV2Request";
import { usePriceTierDiscountCreate } from "../../../../../hooks/api/v2/priceTierDiscount/usePriceTierDiscountCreate";
import {
  PriceTierDiscountForm,
  PriceTierDiscountFormValues,
} from "./PriceTierDiscountForm";

const formId = v4();

export const PriceTierDiscountDialogCreate = ({
  priceTierId,
  volumeDiscountsId,
  active,
  onDismiss,
}: {
  priceTierId?: number;
  volumeDiscountsId: number | null;
  active: boolean;
  onDismiss: () => void;
}) => {
  const form = useForm<PriceTierDiscountFormValues>({
    shouldUseNativeValidation: true,
    defaultValues: {
      discountByType: "minimumOrderQuantity",
      type: "percentage",
      itemType: "any",
    },
  });

  const priceTierDiscountCreateMutation = usePriceTierDiscountCreate();

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={`Add price tier discount`}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />
      <DialogContent>
        <PriceTierDiscountForm
          key={formId}
          form={form}
          formId={formId}
          onSave={(data) => {
            priceTierDiscountCreateMutation.mutate(
              {
                ...data,
                PriceTierId: priceTierId,
                VolumeDiscountsId: volumeDiscountsId,
              },
              {
                onSuccess: () => {
                  onDismiss();
                },
              },
            );
          }}
        />
        {priceTierDiscountCreateMutation.isError ? (
          <Alert
            message={
              apiV2AssertError(priceTierDiscountCreateMutation.error)?.response
                ?.data.message ?? "Unknown error"
            }
          ></Alert>
        ) : null}
      </DialogContent>
      <DialogCTA>
        <Button
          loading={priceTierDiscountCreateMutation.isPending}
          form={formId}
          type={"submit"}
        >
          Add
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
